export default __webpack_public_path__ + "static/media/gridImage14.d5f28a06.png";